import { useStore } from '@balm-ui';

export default ({ getModelConfigPath }) =>
  async function getModelConfigFn({ model, modelPath }) {
    const $store = useStore();

    const path = getModelConfigPath
      ? getModelConfigPath({ model, modelPath })
      : modelPath;

    return await $store.$getModelConfig(path, model);
  };
